import {useState,useRef, useEffect} from 'react';
import styles from './style.module.css'
import toUpperFirstCase from '../../utils/toUpperFirstCase';
import Portal from '../../utils/Portal';

const roleData=[
    'owner',
    'member',
    'guest',
]

export default function Dropdown({list=null,selected,onChange,styleWidth=null,isUpperCase=true}){
    const [isOpen,setIsOpen]=useState(false);
    const [nowRole,setNowRole]=useState(selected);
    const ref=useRef(null);
    const menuRef=useRef(null);
    const [pos,setPos]=useState({x:0,y:0})

    const handleItem=(value)=>{
      setNowRole(value)
      onChange(value)
    }

    const handleClick=()=>{
      const btnRect=ref.current.getBoundingClientRect();
      setPos({
          x:btnRect.left,
          y:btnRect.bottom + 4,
      })
      setIsOpen(!isOpen)
    }

    const handleOutsideClick=(e)=>{
      if(ref.current && !ref.current.contains(e.target)){
        if(menuRef.current && !menuRef.current.contains(e.target)){
            setIsOpen(false);
        }
      }
    }

    useEffect(()=>{
        if(isOpen){
            document.addEventListener('mousedown',handleOutsideClick);
        }else{
            document.removeEventListener('mousedown',handleOutsideClick);
        }
        return()=>{
            document.removeEventListener('mousedown',handleOutsideClick);
        }
    },[isOpen])




    return(
        <div 
        ref={ref} 
        className={`${styles['wrap']} ${isOpen&&styles['wrap-hover']}`}
        style={{
          width:styleWidth+'px',
        }}
        onClick={handleClick}>
          <span>{isUpperCase?toUpperFirstCase(nowRole):nowRole}</span>
          <div className={`${styles['arrow']} ${isOpen&&styles['arrow-on']}`}>&gt;</div>
          {isOpen&&
          <Portal>
            <div 
            ref={menuRef}
            className={styles['body']}
            style={{
                top:pos.y, 
                left:pos.x,
                width:styleWidth&&(styleWidth+20+'px'),
                position:'absolute'
            }}>
              {Object.values(list?list:roleData).map(value=>
              <div 
              className={`${styles['body-item']} ${value.name==nowRole&&styles['body-item-hover']}`}
              onClick={()=>handleItem(value)}>
                <span>{isUpperCase?toUpperFirstCase(value):value}</span>
              </div>
              )}
            </div>
          </Portal>
          }
        </div>
    )
}